import Select from 'antd/lib/select';

import { StyledSelect } from './styles';

type Props = React.ComponentProps<typeof Select>;

export function UiSelect(props: Props) {
  return <StyledSelect {...props} />;
}
